<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'agendamentosCrud'"
          crudName="Agendamentos"
          newText="Novo Agendamento"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableDownloadPdf="false"
          :enableDownloadExcel="false"
          :enableCalendar="true"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="true"
          :enableActive="false"
          :enableReset="false"
          :enableSenhaPath="false"
          :customFilters="customFilters"
          :dataForm="dataForm"
          @filtered_ds="filtered_ds"
        >
          <template v-slot:header-actions>
            <button
              type="button"
              class="btn btn-sm btn-success mr-1 mb-1"
              style="float: right; margin-top: -5px"
              @click="abrirModalExcel"
            >
              <i class="fas fa-file-excel"></i> Baixar Excel
            </button>
          </template>
        </base-crud>
      </div>
    </div>

    <div
      class="modal fade"
      id="modalExcelAgendamentos"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Exportar Agendamentos — Período</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Fechar"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Data Início</label>
              <input
                type="date"
                class="form-control"
                v-model="excelDataInicio"
                :max="excelDataFim || null"
              />
            </div>
            <div class="form-group">
              <label>Data Fim</label>
              <input
                type="date"
                class="form-control"
                v-model="excelDataFim"
                :min="excelDataInicio"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="confirmarDownloadExcel"
            >
              <i class="fas fa-file-excel"></i> Baixar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      customFilters: [
        {
          name: "data_agendado",
          type: "calendar",
          call: "filtered_ds",
        },
      ],
      data_agendado: "",
      excelDataInicio: "",
      excelDataFim: "",
      table: "agendamentosTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: ["id", "nome", "cpf", "data_agendado", "status", "actions"],
      tableData: ["id", "nome", "cpf", "data_agendado", "status"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "nome", "cpf", "status"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          nome: "Nome",
          data_agendado: "Data Agendada",
          actions: "Ações",
        },
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          status: [
            {
              id: 0,
              text: "Agendamento Cancelado",
            },
            {
              id: 1,
              text: "Agendado",
            },
            {
              id: 2,
              text: "Ausente",
            },
            {
              id: 3,
              text: "Presente",
            },
            {
              id: 4,
              text: "Atendido",
            },
          ],
        },
        templates: {
          status: function (h, row, index) {
            switch (row.status) {
              case 0:
                return (
                  <h6 class="text-center">
                    <span class="badge badge-danger">
                      Agendamento Cancelado
                    </span>
                  </h6>
                );
              case 1:
                return (
                  <h6 class="text-center">
                    <span class="badge badge-primary">Agendado</span>
                  </h6>
                );
              case 2:
                return (
                  <h6 class="text-center">
                    <span class="badge badge-danger">Ausente</span>
                  </h6>
                );
              case 3:
                return (
                  <h6 class="text-center">
                    <span class="badge badge-success">Presente</span>
                  </h6>
                );
              case 4:
                return (
                  <h6 class="text-center">
                    <span class="badge badge-secondary">Atendido</span>
                  </h6>
                );
            }
          },
          data_agendado: function (h, row, index) {
            return row.data_agendado ? row.data_agendado_f : "";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;

          if (
            this.$parent.$parent.$parent.data_agendado != null &&
            this.$parent.$parent.$parent.data_agendado != ""
          ) {
            requestData.params.data_agendado =
              this.$parent.$parent.$parent.data_agendado;
          }

          requestData.params.query = "";
          requestData.params.with = [];

          return this.$http
            .get(this.url + "?orderByDesc=id&" + query, requestData)
            .catch(
              function (e) {
                this.dispatch("error", e);
              }.bind(this)
            );
        },
      },
      endPoint: "agendamentos/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    filtered_ds(date) {
      this.data_agendado = date;
    },
    abrirModalExcel() {
      $("#modalExcelAgendamentos").modal("toggle");
    },
    confirmarDownloadExcel() {
      const self = this;

      if (!self.excelDataInicio || !self.excelDataFim) {
        self.$message(null, "Selecione a Data Início e a Data Fim", "warning");
        return;
      }

      if (self.excelDataInicio > self.excelDataFim) {
        self.$message(
          null,
          "A Data Início não pode ser posterior à Data Fim",
          "warning"
        );
        return;
      }

      const params = new URLSearchParams();
      params.append("data_inicio", self.excelDataInicio);
      params.append("data_fim", self.excelDataFim);

      window.open(
        `${self.$store.state.url}excel/${self.endPoint}?${params.toString()}`,
        "_blank"
      );

      $("#modalExcelAgendamentos").modal("toggle");
    },
    query: function (query) {
      let columns = {
        id: "id",
        nome: "nome",
        cpf: "cpf",
        data_agendado: "data_agendado",
        status: "status",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>